import { useEffect } from 'react'
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectProps,
  Typography,
  useTheme,
} from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { AmericanStatesActions, AmericanStatesSelector } from '../../../store/AmericanStates'

interface StateDropdownProps extends Omit<SelectProps, 'onChange'> {
  onChange: (value: string) => void
  label?: string
}

export const StateDropdown: React.FC<StateDropdownProps> = ({
  onChange,
  value,
  label,
  ...props
}) => {
  const dispatch = useDispatch()
  const states = useSelector(AmericanStatesSelector.makeSortedStates)
  const theme = useTheme()

  useEffect(() => {
    dispatch(AmericanStatesActions.fetchAmericanStatesAsync() as any)
  }, [dispatch])

  return (
    <Box width={'100%'}>
      {label && (
        <Typography
          fontSize={'0.875rem'}
          color={theme.palette.primary.dark}
          sx={{ mb: 1, fontWeight: 500 }}
        >
          {label}
        </Typography>
      )}
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={(e: any) => onChange(e.target.value)}
          displayEmpty
          renderValue={(selected: any) => {
            if (!selected) {
              return <span style={{ color: "#94a3b880" }}>Select State</span>
            }
            return selected
          }}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: `${theme.palette.divider} !important`,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: `${theme.palette.divider} !important`,
            },
            '& .MuiSelect-icon': {
              color: theme.palette.primary.dark,
            },
            backgroundColor: 'white',
            color: theme.palette.primary.dark,
            borderRadius: '6px',
          }}
          {...props}
        >
          <MenuItem value="" disabled>
            Select State
          </MenuItem>
          {states.map((state) => (
            <MenuItem key={state.state} value={state.state_abbr}>
              {state.state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
